export const FILTER_SET = 'filter-set';

export const NOTE_ADD = 'note-add';
export const NOTE_REMOVE = 'note-remove';
export const NOTE_SELECT = 'note-select';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/